export const BRANDING = {
  SETTING: "brandingOptions", 
  LOGO: "logo",
  FAVICON: "favicon",
  SITE_IMAGE: "siteImage",
  COLOR: "color",
  AVATAR_FALLBACK_URL: "https://static.contentcamel.io/cc-static-avatar-example.png"
};